import React from 'react';
import { Formik } from 'formik';
import Modal from 'petco-ui/components/modal/Modal';
import { useModalControl } from '@/common/hooks/useModalControl';
import { Carousel, ErrorNotice } from '@/shared/ui/components';
import { useSaveShiftPreferences } from './hooks/use-save-shift-preferences';
import { Intro } from './components/Intro';
import { SelectDays } from './components/SelectDays';
import { SelectPeriodTime } from './components/SelectPeriodTime';
import { SelectWeeks } from './components/SelectWeeks';
import { SelectDistance } from './components/SelectDistance';
import { SelectTypes } from './components/SelectTypes';
import { SelectAreas } from './components/SelectAreas';
import { ModalContainer } from './ShiftPreferencesModal.styled';
import { useConvertShiftPreferences } from './hooks/use-convert-shift-preferences';

const defaultValues = {
  shiftTypes__vaccination: false,
  shiftTypes__wellness: false,
  shiftTypes__hospital: false,
  weekdays__1: false,
  weekdays__2: false,
  weekdays__3: false,
  weekdays__4: false,
  weekdays__5: false,
  weekdays__6: false,
  weekdays__7: false,
  periodTime__morning: false,
  periodTime__afternoon: false,
  periodTime__evening: false,
  weeks__first: false,
  weeks__second: false,
  weeks__third: false,
  weeks__fourth: false,
  distance: 25,
  areas__wellness: false,
  areas__nonWellness: false,
  areas__dental: false,
  areas__electiveSurgery: false,
  areas__nonElectiveSurgery: false,
  areas__euthanasia: false,
};

export default ({
  show,
  forEdit,
  initialSlide,
  initialValues,
  onSubmit,
}) => {
  const sliderRef = React.useRef();
  const formRef = React.useRef();
  const [selecting, setSelecting] = React.useState(false);
  const [error, setError] = React.useState('');
  const { convertToFormInitialValues } = useConvertShiftPreferences();
  const { actions } = useModalControl();

  const { onSubmit: handleSavePreferences } = useSaveShiftPreferences({
    externalSubmit: onSubmit,
    handleError: setError,
  });

  const handleCloseModal = () => {
    if (selecting && !forEdit) {
      return formRef.current?.handleSubmit();
    }

    return actions.close();
  };

  const convertedInitialValues = convertToFormInitialValues(initialValues);

  return (
    <Modal show={show} onCloseAction={handleCloseModal} modifiers="small">
      <Formik
        innerRef={formRef}
        initialValues={convertedInitialValues || defaultValues}
        onSubmit={handleSavePreferences}
      >
        {({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <ModalContainer>
              {selecting || forEdit ? (
                <>
                  {error && <ErrorNotice message={error} />}
                  <Carousel
                    ref={sliderRef}
                    swipe={false}
                    modifiers={error ? 'error' : ''}
                    dots={!forEdit}
                    initialSlide={initialSlide}
                  >
                    <SelectDays slick={sliderRef} forEdit={forEdit} />
                    <SelectPeriodTime slick={sliderRef} forEdit={forEdit} />
                    <SelectWeeks slick={sliderRef} forEdit={forEdit} />
                    <SelectDistance slick={sliderRef} forEdit={forEdit} />
                    <SelectTypes slick={sliderRef} forEdit={forEdit} />
                    <SelectAreas forEdit={forEdit} />
                  </Carousel>
                </>
              ) : (
                <Intro setSelecting={() => setSelecting(true)} />
              )}
            </ModalContainer>
          </form>
        )}
      </Formik>
    </Modal>
  );
};
